import { render, staticRenderFns } from "./main-vehicle.vue?vue&type=template&id=0ad64400&scoped=true&"
import script from "./main-vehicle.vue?vue&type=script&lang=js&"
export * from "./main-vehicle.vue?vue&type=script&lang=js&"
import style0 from "./main-vehicle.vue?vue&type=style&index=0&id=0ad64400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad64400",
  null
  
)

export default component.exports